import React, { useState, useRef, useEffect } from 'react';
import { FiMapPin, FiPhone, FiMail,  } from 'react-icons/fi';
import { CiInstagram } from "react-icons/ci";

function CateringService() {
  const galleryImages = [
    "catering-f","catering-b","catering-d",
  "catering-8",
   "catering-3","catering-c","catering-5",
    "catering-2","catering-h"
  ];

  const [visibleCount, setVisibleCount] = useState(6);

  return (
    <main className="main">

      {/* Page Title */}
      <div className="page-title dark-background">
        <div className="container text-center">
          <h1 className="page-heading">Catering Services</h1>
          <p className="page-subtitle">Quality meals for Umrah, Hajj, corporate teams, and community programs</p>
          <nav className="breadcrumbs">
            <ol>
              <li><a href="/">Home</a></li>
              <li className="current">Catering Services</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Service Details */}
      <section className="service-details section">
        <div className="container">

          {/* Main Image */}
          <div className="main-image-container">
            <img src="/assets/catering/catering-h.webp" alt="Catering Services" className="main-image" />
          </div>

          {/* Overview & Branch Profile */}
          <h2>Overview</h2>
          <p>
            Our Catering Services Branch in Makkah specializes in delivering high-quality meals for Umrah groups, Hajj pilgrims, 
            corporate teams, and community programs. We provide a wide variety of freshly prepared dishes from multiple international 
            cuisines, including Indian, Chinese, Filipino, Pakistani, and Saudi foods—crafted by experienced chefs who understand 
            authentic taste and cultural preferences.
          </p>

          <h2>Branch Profile</h2>
          <p>
            Our Catering Services Branch in Makkah is a specialized division dedicated to providing high-quality catering solutions 
            for Umrah groups, Hajj pilgrims, corporate teams, and community events. We offer a diverse range of international cuisines prepared by skilled chefs using fresh, high-quality ingredients.
          </p>
          <p>
            The branch is equipped with professional kitchens, organized food preparation systems, and efficient delivery mechanisms 
            to handle both small and large-scale catering requirements. We serve daily meals, special menus, buffets, and packaged food 
            services with strict adherence to hygiene and food safety standards.
          </p>

          {/* Products Section */}
          <h2>Products</h2>

          <h3>Indian Cuisine</h3>
          <div className="product-row">
            Biryani (chicken, mutton, vegetable), Butter chicken, Chicken tikka, Paneer dishes (paneer butter masala, palak paneer),
            Dal tadka / Dal makhani, Naan, roti, paratha, Rice varieties (jeera rice, plain rice, pulao), Samosas, pakoras, Indian snacks
          </div>

          <h3>Chinese Cuisine</h3>
          <div className="product-row">
            Fried rice (vegetable, chicken, shrimp), Hakka noodles / chow mein, Sweet and sour chicken / fish, Manchurian (vegetable, chicken),
            Spring rolls, Dumplings, Hot & sour soup / sweet corn soup
          </div>

          <h3>Filipino Cuisine</h3>
          <div className="product-row">
            Adobo (chicken, pork), Sinigang (sour soup), Pancit noodles, Lechon (roasted pork / chicken if available),
            Lumpia (Filipino spring rolls), Filipino rice dishes
          </div>

          <h3>Pakistani Cuisine</h3>
          <div className="product-row">
            Nihari, Karahi (chicken, mutton), Seekh kebabs, Chapli kebabs, Biryani (chicken, beef), Roti, naan, paratha, Lentil dishes and curries
          </div>

          <h3>Saudi / Middle Eastern Cuisine</h3>
          <div className="product-row">
            Kabsa / Mandi rice with chicken or lamb, Shawarma wraps (chicken, beef), Grilled kebabs, Hummus, mutabbal, tabbouleh,
            Falafel, Arabic bread / pita
          </div>

          <h3>Other / General Food Items</h3>
          <div className="product-row">
            Breakfast items (eggs, pancakes, cereals), Sandwiches / wraps, Salads (fresh vegetable, pasta, fruit),
            Desserts (cakes, puddings, traditional sweets), Cold beverages (juice, soft drinks, water), Tea / coffee
          </div>

          <h3>Catering Services</h3>
          <div className="product-row">
            Daily meals for Umrah and Hajj groups, Group / corporate meal packages, Buffets for events and special occasions,
            Packed / boxed meals for tours and pilgrims, Special menus based on cuisine or dietary requirements,
            On-demand delivery for hotels, organizations, and restaurants, Event catering management (kitchen setup, serving staff, table setup)
          </div>

          <h3>Additional Services</h3>
          <div className="product-row">
            Customized meal planning for large groups, Hygiene and food safety compliance, Timely delivery with hot & fresh meals,
            Multi-cuisine menu options in one package, Staffing support for serving and event management
          </div>

        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2 className="gallery-title">Gallery</h2>
          <div className="gallery-grid">
            {galleryImages.slice(0, visibleCount).map((img, index) => (
              <LazyImage 
                key={img} 
                src={`/assets/catering/${img}.webp`} 
                alt={`Catering ${index + 1}`} 
                priority={index===0} 
              />
            ))}
          </div>

          {visibleCount < galleryImages.length && (
            <div className="load-more">
              <button onClick={() => setVisibleCount(v => v + 4)}>Load More</button>
            </div>
          )}
        </div>
      </section>

      {/* Location & Contact */}
      <section className="contact-strip">
        <div className="container">
          <h3 className="contact-heading">Location & Contact</h3>
          <div className="contact-row">
            <span><FiMapPin /> MAKKAH-KSA</span>
            <span><FiPhone /> +966 568205558</span>
            {/* <span><FiMail /> example@email.com</span> */}
              <a
                            href="https://www.instagram.com/almac_company?igsh=MThmemIyN2d6aG8zeQ=="
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <CiInstagram style={{ fontSize: '28px', color: '#111' }} />

                          </a>
          </div>
        </div>
      </section>

      {/* Styles */}
      <style>{`
        .page-heading { font-size: 3rem; font-weight: 800; color:#fff; text-shadow:2px2px5px rgba(0,0,0,0.6); margin-bottom:10px; }
        .page-subtitle { font-size:1.2rem; color:#e6e6e6; margin-bottom:15px; }
        h2 { font-size:2rem; margin-top:30px; margin-bottom:15px; color:#222; }
        h3 { font-size:1.6rem; margin-top:25px; margin-bottom:12px; color:#333; }
        p, .product-row { font-size:1.1rem; line-height:1.8; color:#555; margin-bottom:12px; }
        .product-row { display:flex; flex-wrap:wrap; gap:12px; }

        .main-image-container { text-align:center; margin-bottom:35px; }
        .main-image { width:100%; max-width:900px; height:auto; border-radius:12px; }

        .gallery-title { text-align:center; font-size:2rem; margin-bottom:25px; }
        .gallery-grid {
          display:grid;
          grid-template-columns:repeat(auto-fit,minmax(230px,1fr));
          gap:15px;
          margin-top:20px;
        }
        .img-wrapper { width:100%; height:220px; border-radius:12px; overflow:hidden; background:#f2f2f2; }
        .img-wrapper img { width:100%; height:100%; object-fit:cover; transition:transform 0.25s ease; }
        .img-wrapper:hover img { transform:scale(1.04); }
        .load-more { text-align:center; margin-top:20px; }
        .load-more button { padding:10px 25px; border-radius:30px; border:none; background:#111; color:#fff; cursor:pointer; font-size:14px; }

        .contact-strip { background:#fafafa; border-top:1px solid #eee; margin-top:50px; padding:40px 0; }
        .contact-heading { text-align:center; font-size:1.7rem; margin-bottom:20px; font-weight:700; color:#222; }
        .contact-row { display:flex; justify-content:center; align-items:center; gap:25px; flex-wrap:wrap; font-size:1rem; color:#333; }
        .contact-row span, .contact-row a { display:flex; align-items:center; gap:8px; text-decoration:none; font-weight:500; color:#333; }
        .contact-row svg { font-size:1.3rem; color:#111; }

        @media(max-width:991px){
          .product-row { font-size:1rem; gap:8px; }
        }
        @media(max-width:576px){
          .product-row { flex-direction:column; gap:5px; }
          .gallery-grid { grid-template-columns:repeat(auto-fit,minmax(200px,1fr)); }
        }
      `}</style>
    </main>
  );
}

/* LazyImage Component */
function LazyImage({ src, alt, priority }) {
  const ref = useRef(null);
  const [show, setShow] = useState(priority);

  useEffect(() => {
    if (priority) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShow(true);
        observer.disconnect();
      }
    }, { rootMargin: "150px" });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [priority]);

  return (
    <div className="img-wrapper" ref={ref}>
      {show && <img src={src} alt={alt} loading={priority ? "eager" : "lazy"} />}
    </div>
  );
}

export default CateringService;
